// React
import React, { useEffect, useState, useRef, useCallback } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, ButtonCell, Cell, Section, IconButton, Input } from '@telegram-apps/telegram-ui';

// Icons
import { ReactComponent as HomeIcon } from "../assets/home.svg";
import { ReactComponent as AddIcon } from "../assets/add.svg";
import { ReactComponent as DeleteIcon } from "../assets/delete.svg";

const tg = window.Telegram.WebApp;

const StreamsPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, setSelectedGroup, activeView, setActiveView, premodePosts }) => {
    const [streams, setStreams] = useState(selectedGroup.streams);
    const streamsRef = useRef(streams); // Добавляем ref для отслеживания актуального состояния

    // Обновляем ref при изменении streams
    useEffect(() => {
        streamsRef.current = streams;
    }, [streams]);

    const groupId = selectedGroup ? selectedGroup.id : null;

    const saveStreams = useCallback(async (streamsToSave) => {
        if (!groupId) return false;
        const url = 'https://api.gmpapp.ru/save_streams';
        const streamsToSend = streamsToSave.slice(1);

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    streams: streamsToSend, 
                    group_id: groupId 
                }),
            });

            if (!response.ok) {
                console.error('Error:', response.status, response.statusText);
                return false;
            }
            
            const data = await response.json();
            console.log('Success:', data);
            
            // Оптимистичное обновление
            if (setSelectedGroup) {
                setSelectedGroup(prevGroup => {
                    if (!prevGroup) return prevGroup;
                    // Изменяем локальную копию объекта и отдаем новый
                    prevGroup.streams = streamsToSave;
                    return { ...prevGroup, streams: streamsToSave };
                });
            }
            
            return true;
        } catch (error) {
            console.error('Error streams sending', error);
            return false;
        }
    }, [groupId, setSelectedGroup]);

    useEffect(() => {
        saveStreams(streams);
    }, [streams, saveStreams]);

    useEffect(() => {
        const backButtonHandler = async () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'streams') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel, setActivePanel]);

    const addStream = () => {
        // Получаем параметры из первого стрима, исключая name
        const { name, premode, premode_time, ...firstStreamParams } = streams[0];

        // Создаем новый стрим на основе этих параметров, установив новое имя
        const newStream = { ...firstStreamParams, id: streams.length, name: `Рубрика ${streams.length + 1}` };

        // Обновляем массив streams
        const updatedStreams = [...streams, newStream].map((stream, index) => {
            // Не изменяем первый стрим
            if (index === 0) return stream;
            // Обновляем id для всех остальных стримов, начиная с 1
            return { ...stream, id: index };
        });

        // Устанавливаем обновленный массив в состояние
        setStreams(updatedStreams);
        console.log(updatedStreams);
    };

    const deleteStream = (id) => {
        // Обновляем массив streams, фильтруя стримы по id
        console.log(id)
        const updatedStreams = streams.filter(stream => stream.id !== id);

        // Устанавливаем обновленный массив в состояние
        setStreams(updatedStreams);
        console.log(updatedStreams);
    };

    const renameStream = (id, newName) => {
        const renamedStreams = streams.map(stream => {
          if (stream.id === id) {
            return { ...stream, name: newName };
          }
          return stream;
        });
    
        setStreams(renamedStreams);
        console.log(renamedStreams)
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Section className='sectionChannelStreams' header="Управление рубриками" footer="«Рубрики» позволяют настраивать уникальные параметры для публикаций, включая источники, ключевые слова и стиль, в зависимости от таймеров и дней недели. У каждой рубрики есть свои индивидуальные параметры на странице вашего канала">
                    <Cell before={<HomeIcon className="SettingsItemIcon" />} multiline subtitle="Основная рубрика не может быть переименована или удалена">Основная</Cell>
                    {streams.slice(1).map((stream, index) => (
                        <Input after={<IconButton className='deleteStream' mode="bezeled" size="m"><DeleteIcon style={{ width: '20px', height: '20px' }} onClick={() => deleteStream(stream.id)} /></IconButton>} header="Input" key={index} defaultValue={stream.name} value={stream.name} onChange={(e) => renameStream(stream.id, e.target.value)} />
                    ))}
                    <ButtonCell className="addStream" style={{ color: '#2688eb' }} before={<AddIcon />} onClick={addStream}>Добавить рубрику</ButtonCell>
                </Section>
            </AppRoot>
        </div>
    );
};

export default StreamsPage;